import { SHORTCUT_PRODUCT_GROUP_FIELDS } from '@@partner:graphql/shortcuts'
import { ProductGroup } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useQuery } from '@apollo/client'

type Variables = {
  id?: GQL_ID | null
}

type Query = {
  singleProductGroup: ProductGroup
}


export const GQL_QUERY_SINGLE_PRODUCT_GROUP = gql`
  query singleProductGroup ($id: ID!) {
    singleProductGroup(id: $id) {
      ${SHORTCUT_PRODUCT_GROUP_FIELDS}
    }
  }
`

export const useFetchSingleProductGroup = (variables: Variables) => useQuery<Query, Variables>(GQL_QUERY_SINGLE_PRODUCT_GROUP, {
  variables,
  skip: !variables.id
})